import Layout from '@/layouts/Layout'

const returnLease = {
  path: '/return_lease',
  component: Layout,
  name: 'return_lease',
  meta: {
    title: '退租',
  },
  children: [
    {
      path: '/returnLease/returnCar/list',
      name: 'return_lease_list',
      component: () => import('@/pages/cars/returnCar/list/index.vue'),
      meta: { title: '客户还车', logEvent: '' },
    },
    {
      path: '/returnLease/returnCar/personalAdd',
      name: 'return_lease_start',
      component: () => import('@/pages/cars/returnCar/add/index.vue'),
      meta: { title: '个人客户还车',
        logEvent: '',
        keepAlive: false,
        parent: [
          {
            path: '/returnLease/returnCar/list',
            name: 'return_lease_list',
            title: '客户还车',
          },
          {
            path: '/workbench/rentOrder/list',
            name: 'workbench_rent_order',
            title: '个人租赁订单',
          },
          {
            path: '/underLease/underLeaseOrder',
            name: 'under_lease_order',
            title: '租赁中订单列表',
          },
        ] },
    },
    {
      path: '/returnLease/returnCar/enterpriseAdd',
      name: 'return_lease_ent_start',
      component: () => import('@/pages/cars/returnCar/add/index'),
      meta: { title: '企业客户还车',
        logEvent: '',
        keepAlive: false,
        parent: [
          {
            path: '/returnLease/returnCar/list',
            name: 'return_lease_list',
            title: '客户还车',
          },
          {
            path: '/underLease/underLeaseOrder',
            name: 'under_lease_order',
            title: '租赁中订单列表',
          },
        ] },
      hidden: true,
    },
    {
      path: '/returnLease/returnCar/personalDetail',
      name: 'return_lease_detail',
      component: () => import('@/pages/cars/returnCar/detail/index.vue'),
      meta: { title: '个人客户还车', logEvent: '' },
      hidden: true,
    },
    {
      path: '/returnLease/returnCar/enterpriseDetail',
      name: 'return_lease_detail_enterprise',
      component: () => import('@/pages/cars/returnCar/detail/index'),
      meta: { title: '企业客户还车', logEvent: '' },
      hidden: true,
    },
    {
      path: '/returnLease/returnCar/orderDetail',
      name: 'return_lease_settle',
      component: () => import('@/pages/orders/paymentDetail'),
      meta: { title: '订单收款详情' },
      hidden: true,
    },
  ],
}
export default returnLease
